import {
  getTemplatesBatchService,
  getTopicsService,
  getTemplatesService,
  getTemplateCategoriesService,
  getTemplateDetailService,
  getTemplateDetailShareService,
} from '../services/template';
import { request } from './index';

export const getTemplatesBatch = async ({
  codes = 'recommend',
  version = process.env.SDK_VERSION,
} = {}) => {
  const { IS_IOS } = await import('@/constants');
  return new Promise((resolve, reject) => {
    request(
      `/templates/v2/codes/${codes}`,
      getTemplatesBatchService.bind(this, {
        codes,
        sdk_version: version,
        os: IS_IOS ? 'ios' : 'android',
      }),
    ).then(({ items }) => {
      resolve(items);
    }).catch((e) => {
      reject(e);
    });
  });
};

export const getTopicsBatch = async ({
  slugs,
  limit,
  embed,
} = {}) => {
  const { IS_IOS } = await import('@/constants');
  return new Promise((resolve, reject) => {
    request(
      `/topics/slugs/${slugs}`,
      getTopicsService.bind(this, {
        slugs,
        limit,
        embed,
        os: IS_IOS ? 'ios' : 'android',
      }),
    ).then(({ items }) => {
      resolve(items);
    }).catch((e) => {
      reject(e);
    });
  });
};

export const getRecommendTemplates = async ({
  code = 'recommend',
  version = process.env.SDK_VERSION,
  autoRetry = false,
} = {}) => {
  const { IS_IOS } = await import('@/constants');
  return new Promise((resolve, reject) => {
    request(
      `/templates/v2/${code}`,
      getTemplatesService.bind(this, {
        template_category_code: code,
        sdk_version: version,
        os: IS_IOS ? 'ios' : 'android',
      }),
    ).then(({ items = []} = {}) => {
      if (items.length === 0 && autoRetry) {
        request(
          'getLastestTemplates',
          getTemplateCategoriesService.bind(this),
        ).then(({ items: categories }) => {
          getRecommendTemplates({ code: categories[0].code });
        }).catch((err) => err);
      } else {
        resolve(items);
      }
    }).catch((err) => {
      reject(err);
    });
  });
};

export const getTemplateDetail = async ({
  code,
  os,
}) => {
  const { IS_IOS } = await import('@/constants');
  const osValue = IS_IOS ? 'ios' : 'android';
  return new Promise((resolve, reject) => {
    request(
      `/templates/${code}`,
      getTemplateDetailService.bind(this, {
        code,
        os: os || osValue,
      }),
    ).then(({ item }) => {
      resolve(item);
    }).catch((err) => {
      reject(err);
    });
  });
};

export const getTemplateShareDetail = ({
  code,
  ...params
}) => new Promise((resolve, reject) => {
  request(
    `/shares/templates/${code}`,
    getTemplateDetailShareService.bind(this, {
      code,
      params,
    }),
  ).then(({ item }) => {
    resolve(item);
  }).catch(() => {
    reject();
  });
});
